import React from "react";

import { IconProps } from "../services/Icon.types";

const ServiceIcon: React.FC<IconProps> = ({ colourFill }) => {

    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M32.1429 0H3.85714C2.83416 0 1.85309 0.406377 1.12973 1.12973C0.406376 1.85309 0 2.83416 0 3.85714L0 32.1429C0 33.1658 0.406376 34.1469 1.12973 34.8703C1.85309 35.5936 2.83416 36 3.85714 36H14.8862V23.7608H9.82366V18H14.8862V13.6093C14.8862 8.61509 17.8594 5.85643 22.4132 5.85643C24.5941 5.85643 26.8746 6.24536 26.8746 6.24536V11.1471H24.3619C21.8861 11.1471 21.1138 12.6836 21.1138 14.2594V18H26.6408L25.7569 23.7608H21.1138V36H32.1429C33.1658 36 34.1469 35.5936 34.8703 34.8703C35.5936 34.1469 36 33.1658 36 32.1429V3.85714C36 2.83416 35.5936 1.85309 34.8703 1.12973C34.1469 0.406377 33.1658 0 32.1429 0V0Z" fill={colourFill}/>
        </svg>
    )
} 


export default ServiceIcon;

